import http from "./HttpService";

const BASE_SERVICE_URL = "ocr-service";

export default {
  getMicrositeCampaignList(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v1/microsite/customer/campaigns/list`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },

  getCustomerDesign(header) {
    return new Promise((resolve, reject) => {
      http
        .get(
          `${BASE_SERVICE_URL}/v1/customer/design`,
          header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },

  getCampaignDetails(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v1/customer/campaign/details`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },

  joinCampaign(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v1/service/customer/campaigns/join`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  }
};
